import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  size: 'full',
  path: 'clients',
} as const satisfies Location
